import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals.scss";
import "./i18n";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./app/store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// Suppress benign Chrome ResizeObserver dev warnings appearing as errors in CRA overlay
// See: https://github.com/WICG/resize-observer/issues/38
(() => {
  const isResizeObserverError = (evtOrErr) => {
    const msg = (evtOrErr?.message || evtOrErr?.error?.message || "") + "";
    return /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i.test(msg);
  };
  window.addEventListener(
    "error",
    (e) => {
      if (isResizeObserverError(e)) {
        e.stopImmediatePropagation();
      }
    },
    true
  );
  window.addEventListener(
    "unhandledrejection",
    (e) => {
      if (isResizeObserverError(e?.reason)) {
        e.preventDefault();
      }
    },
    true
  );
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

serviceWorkerRegistration.register();
